<template>
	<v-card-text>
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">people</v-icon>
			<v-toolbar-title>Profil publiczny</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-switch
						aria-label="public profile"
						v-model="data.presentOnList"
						:label="data.presentOnList ? 'Profil jest opublikowany. Kliknij, żeby ukryć' : 'Profil jest ukryty. Kliknij, żeby opublikować'"
						for="other-profile-data-view-display-me"
						id="other-profile-data-view-display-me"
						color="primary"
						hide-details
						:disabled="readOnlyMode"
						class="mb-4"
					></v-switch>
				</v-flex>
			</v-layout>
			<v-layout row class="mb-2">
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						v-model="data.polishDescription"
						label="Opis organizacji po polsku"
						aria-label="polish description"
						for="other-profile-data-view-polish-name-organization"
						id="other-profile-data-view-polish-name-organization"
						maxlength="2000"
						counter="2000"
						:disabled="readOnlyMode"
						auto-grow
						outline/>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						v-model="data.englishDescription"
						aria-label="english description"
						label="Opis organizacji po angielsku"
						for="other-profile-data-view-english-name-organization"
						id="other-profile-data-view-english-name-organization"
						maxlength="2000"
						counter="2000"
						:disabled="readOnlyMode"
						auto-grow
						outline/>
					<v-flex xs1/>
				</v-flex>
			</v-layout>

			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Kraje działalności</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-select
						multiple
						:readonly="readOnlyMode"
						:items="allActivityCountries"
						aria-label="activity countries"
						item-text="name"
						item-value="API"
						chips
						deletable-chips
						hide-no-data
						v-model="data2.activityCountries"
						return-object
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Rodzaje działalności</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-select
						multiple
						:readonly="readOnlyMode"
						:items="allActivityTypes"
						aria-label="activity types"
						item-text="name"
						item-value="API"
						chips
						deletable-chips
						hide-no-data
						v-model="data2.activityTypes"
						return-object
					></v-select>
				</v-flex>
			</v-layout>

		</div>
	</v-card-text>
</template>

<script>
	import {ActivityType} from "../../../../../api/generated/ActivityType";
	import {AccreditationCountry} from "../../../../../api/generated/AccreditationCountry";
	import {createLabels} from "../../../../../utils/createLabels";

	export default {
		name: "OtherProfileDataView",


		updated() {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},

		data() {
			return {
				readOnlyMode: true,

				data: {},

				data2: {},

				allActivityTypes: [],

				allActivityCountries: [],

				allActivityCountriesFetched: false,

				allActivityTypesFetched: false,
			};
		},

		created() {
			this.fetchAllActivities();
			this.fetchAllActivityCountries();
		},

		watch: {
			otherData: function () {
				this.data = this.otherData;
			},

			organizationData: function () {
				this.data2 = this.organizationData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		methods: {

			async fetchAllActivities() {
				ActivityType.getListAll(this, success => {
					this.allActivityTypes = success;
					this.allActivityTypesFetched = true;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać rodzaju działalności", errorResponse);
				});
			},

			async fetchAllActivityCountries() {
				AccreditationCountry.getListAll(this, successResponse => {
					this.allActivityCountries = successResponse;
					this.allActivityCountries.sort((a, b) => a.name === b.name ? 0 : (a.name < b.name) ? -1 : 1);
					this.allActivityCountriesFetched = true;
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wczytać krajów działalności", errorResponse);
				},
				)
				;
			},
		},

		props: {
			otherData: Object,
			organizationData:
				Object,
			editable: {
				default: true,
			},
		},
	}
	;
</script>

<style scoped>

</style>
